var render = function render(){var _vm=this,_c=_vm._self._c;return _c('project-select',{attrs:{"projects-fetch-path":_vm.projectsAutocompleteEndpoint,"dropdown-button-title":_vm.dropdownButtonTitle,"dropdown-header-title":_vm.$options.i18n.title,"move-in-progress":_vm.moveInProgress},on:{"move-issuable":_vm.moveIssue}})
}
var staticRenderFns = []

export { render, staticRenderFns }